import { isOrganic } from '@s1/core/utilities';
import { ConnatixVideoPlayer } from '../../../../assets/js/core/services/_connatixVideoPlayer';

window.addEventListener('DOMContentLoaded', () => {
  // we're only looking to initalize this if its paid traffic
  const userData = window?.s1?.markupModifier || window?.s1?.blockInjector || {};

  if (!isOrganic(window.location.search, userData?.isOrganic)) {
    // activebeat-specific Connatix IDs.
    const cId = '35ed88c1-5d17-40f7-9b63-11e04c4fbf5c';
    const scriptId = '19747fd3dbc144b493aa3419f541d3f1';
    const token = '64825fd9-49db-43d8-b942-d916e25975d2';

    const connatixVideoPlayer = new ConnatixVideoPlayer(cId, scriptId, token, 'playspace');
    // run on both organic and paid hybrid/single/single-old
    connatixVideoPlayer.init();
  }
});
